export default __webpack_public_path__ + "static/media/email.5f7ac4ef.svg";